<template>
  <div class="ts-space-y-3">
    <div>
      <label class="required">{{ $t('importTaxModel.model') }}</label>
      <input v-model.trim="model.model" class="form-control" />
      <div class="validate" v-if="errors.has('model')">{{ errors.first('model') }}</div>
    </div>
    <div>
      <label class="required">{{ $t('importTaxModel.hsCode') }}</label>
      <input v-model.trim="model.hs_code" class="form-control" />
      <div class="validate" v-if="errors.has('hs_code')">{{ errors.first('hs_code') }}</div>
    </div>
    <div class="row">
      <div class="col-md-4" v-for="field in rateFields" :key="field.key">
        <label class="required">{{ $t(field.label) }}</label>
        <input
          v-model.number="model[field.key]"
          type="number"
          min="0"
          max="1"
          step="0.0001"
          class="form-control"
        />
        <div class="validate" v-if="errors.has(field.key)">
          {{ errors.first(field.key) }}
        </div>
      </div>
    </div>
    <div>
      <label class="ts-block">{{ $t('importTaxModel.isActive') }}</label>
      <a-switch v-model="model.is_active" />
    </div>
    <div class="text-right ts-pt-3">
      <ts-button class="mr-2" @click.prevent="$emit('cancel')">{{ $t('cancel') }}</ts-button>
      <ts-button color="primary" :waiting="waiting" @click.prevent="submit">
        {{ isUpdate ? $t('update') : $t('save') }}
      </ts-button>
    </div>
  </div>
</template>

<script>
import { isEmpty } from 'lodash'
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  name: 'ImportTaxModelForm',
  data() {
    return {
      waiting: false,
      errors: new Errors(),
      model: {
        model: '',
        hs_code: '',
        cpp_rate: null,
        spp_rate: null,
        vpp_rate: null,
        is_active: true
      },
      rateFields: [
        { key: 'cpp_rate', label: 'importTaxModel.cppRate' },
        { key: 'spp_rate', label: 'importTaxModel.sppRate' },
        { key: 'vpp_rate', label: 'importTaxModel.vppRate' }
      ]
    }
  },
  computed: {
    ...mapState('setting/importTaxModel', ['edit_data']),
    isUpdate() {
      return !isEmpty(this.edit_data)
    }
  },
  created() {
    if (this.isUpdate) {
      this.model = {
        model: this.edit_data.model,
        hs_code: this.edit_data.hs_code,
        cpp_rate: Number(this.edit_data.cpp_rate),
        spp_rate: Number(this.edit_data.spp_rate),
        vpp_rate: Number(this.edit_data.vpp_rate),
        is_active: this.edit_data.is_active
      }
    }
  },
  methods: {
    submit() {
      this.waiting = true
      const action = this.isUpdate ? 'update' : 'store'
      const payload = this.isUpdate
        ? { id: this.edit_data.id, data: this.model }
        : this.model

      this.$store
        .dispatch(`setting/importTaxModel/${action}`, payload)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.waiting = false))
    }
  }
}
</script>
